import { createApp } from 'vue'
import routes from './routes'
import App from './App.vue'
import * as Vue from 'vue'
import "bootstrap/dist/css/bootstrap.min.css"
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store';
import Vue3Progress from "vue3-progress";
import {LoadingPlugin} from 'vue-loading-overlay';
window.$ = window.jQuery = require('jquery/dist/jquery');
import Popper from "vue3-popper";
import Bootstrap from "bootstrap"
import Vue3Signature from "vue3-signature"
import VueAwesomePaginate from "vue-awesome-paginate";

const options = {
    position: "fixed",
    height: "3px",
    color: "#000",
};

const app = createApp(App)

app.use(routes)
app.use(store)
app.use(VueAwesomePaginate)
app.use(Bootstrap)
app.use(Vue3Progress, options)
app.use(LoadingPlugin);
app.use(Vue3Signature);
app.mount('#app')
app.use(VueAxios, axios)
app.component("Popper", Popper);
